// extracted by mini-css-extract-plugin
module.exports = {"like":"QuestionReactionIcon_like__1DlbP","dislike":"QuestionReactionIcon_dislike__3A-0X","root":"QuestionReactionIcon_root__2YDYs"};